import { useTranslation } from "react-i18next";
import { MinusIcon, PlusIcon } from "../../../../components/restaurant-schema/schemaIcons";
import { DURATION_OPTIONS, MAX_GUESTS } from "../../logic/newReservation";
import { useReservationFormat } from "../../hooks/useReservationFormat";
import { SectionLabel } from "./formPrimitives";

const STEP_BUTTON =
  "flex h-full w-10 shrink-0 cursor-pointer items-center justify-center border-none bg-transparent text-body transition-colors duration-150 hover:bg-shade-1 hover:text-ink disabled:cursor-not-allowed disabled:text-ghost disabled:hover:bg-transparent";

/** „ГОСТИ − N +" и „ПРОДЪЛЖИТЕЛНОСТ 1 ч / 1,5 ч / 2 ч / 3 ч". */
const GuestsDurationSection = ({
  guests,
  durationMinutes,
  onGuestsChange,
  onDurationChange,
}: {
  guests: number;
  durationMinutes: number;
  onGuestsChange: (guests: number) => void;
  onDurationChange: (minutes: number) => void;
}) => {
  const { t } = useTranslation();
  const format = useReservationFormat();

  return (
    <div className="grid grid-cols-[auto_1fr] gap-x-4 gap-y-2">
      <SectionLabel>{t("reservations.form.guests")}</SectionLabel>
      <SectionLabel>{t("reservations.form.duration")}</SectionLabel>

      <div className="flex h-10 items-stretch overflow-hidden rounded-[10px] border border-shade-3 bg-surface">
        <button
          type="button"
          className={STEP_BUTTON}
          disabled={guests <= 1}
          aria-label={t("reservations.form.fewerGuests")}
          onClick={() => onGuestsChange(guests - 1)}
        >
          <MinusIcon className="size-3.5" />
        </button>
        <span className="flex min-w-9 items-center justify-center text-[15px] font-bold tabular-nums text-ink">
          {guests}
        </span>
        <button
          type="button"
          className={STEP_BUTTON}
          disabled={guests >= MAX_GUESTS}
          aria-label={t("reservations.form.moreGuests")}
          onClick={() => onGuestsChange(guests + 1)}
        >
          <PlusIcon className="size-3.5" />
        </button>
      </div>

      <div className="grid h-10 grid-cols-4 gap-0.5 rounded-[10px] bg-fill p-[3px]" role="radiogroup">
        {DURATION_OPTIONS.map((minutes) => {
          const active = minutes === durationMinutes;
          return (
            <button
              key={minutes}
              type="button"
              role="radio"
              aria-checked={active}
              onClick={() => onDurationChange(minutes)}
              className={`cursor-pointer whitespace-nowrap rounded-[8px] border-none text-[12.5px] font-bold tabular-nums transition-colors duration-150 ${
                active
                  ? "bg-surface text-ink shadow-[0_1px_2px_rgba(28,25,23,0.12)]"
                  : "bg-transparent text-body hover:text-ink"
              }`}
            >
              {format.hours(minutes)}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default GuestsDurationSection;
